<template>
  <div
    class="baseDialog"
    v-if="currThemeObj"
    :style="{
      '--mixtmt_whiteColor': currThemeObj.cssStyle.whiteColor,
      '--mixtmt_mainColor': currThemeObj.cssStyle.mainColor,
      '--mixtmt_mainColor3': currThemeObj.cssStyle.mainColor3,
      '--mixtmt_mainColor8': currThemeObj.cssStyle.mainColor8,
      '--mixtmt_greyColor2': currThemeObj.cssStyle.greyColor2,
      '--mixtmt_greyColor3': currThemeObj.cssStyle.greyColor3,
      '--mixtmt_greyColor6': currThemeObj.cssStyle.greyColor6,
    }"
  >
    <el-dialog
      :title="
        dialogObj.dialogType == 'eidtSingleItem' ? dialogObj.dialogText : '提示'
      "
      custom-class="mixtmt_dialog"
      width="40vw"
      :visible.sync="isShowDialog"
      top="0"
      center
    >
      <span v-show="dialogObj.dialogType != 'eidtSingleItem'">
        <span class="dialogText" v-text="dialogObj.dialogText"></span>
      </span>
      <span v-show="dialogObj.dialogType == 'eidtSingleItem'" class="row_input">
        <span class="row_title">标 题</span>
        <el-input
          type="text"
          placeholder="请输入内容"
          v-model="editThemeTitle"
          maxlength="15"
          show-word-limit
        ></el-input>
      </span>
      <span slot="footer" class="dialog-footer">
        <span @click="clickBtn(false)">取 消</span>
        <span @click="clickBtn(true)" class="ok">确 定</span>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import cup_base_data_mixin from '@mixins/cup_base_data'
export default {
  name: 'baseDialog',
  mixins: [cup_base_data_mixin],
  props: {
    isDialogFlag: {
      type: Boolean,
      default: false,
    },
    dialogObj: {
      type: Object,
      default: () => ({
        dialogType: '',
        dialogText: '',
        mid: 0,
      }),
    },
  },
  data() {
    return {
      isShowDialog: false,
      editThemeTitle: '',
      toParentData: null,
    }
  },
  watch: {
    isShowDialog(newVal, oldVal) {
      // 如果是从b到a页面，则不缓存b
      // 注意 路由那么要与组件name一致

      console.debug(oldVal, newVal)
      if (!newVal) {
        // 关闭时，向父组件传递数据
        this.toParentEvent(this.toParentData)
      }
    },
  },
  created() {
    this.isShowDialog = this.isDialogFlag
  },
  methods: {
    toParentEvent(data) {
      console.debug('toParentEvent:', data)
      this.$emit('baseDialogEvent', data)
    },
    clickBtn(flag) {
      this.toParentData = null
      if (flag) {
        this.toParentData = {
          flag: flag,
          data: {
            editThemeTitle: this.editThemeTitle,
            mid: this.dialogObj.mid,
          },
        }
      }
      this.isShowDialog = false
    },
  },
}
</script>

<style lang="scss">
.baseDialog {
  .el-dialog__wrapper {
    width: 100%;
    z-index: 1610 !important;
    .mixtmt_dialog {
      border-radius: 1.042vw;
      transform: translateY(-50%);
      top: 50%;
      .el-dialog__header {
        padding: 2.083vw 2.778vw 1.043vw 2.778vw;
        .el-dialog__title {
          line-height: 1.8vw;
          font-size: 1.25vw;
          font-weight: bold;
          color: var(--mixtmt_greyColor3);
        }
      }
      .el-dialog__body {
        padding: 1.043vw 2.778vw;
        color: var(--mixtmt_greyColor13);
        .dialogText {
          line-height: 1.388vw;
          font-size: 0.972vw;
          color: var(--mixtmt_greyColor2);
        }
        .row_input {
          display: flex;
          display: -webkit-flex;
          justify-content: flex-start;
          align-items: center;
          width: 100%;
          .row_title {
            padding-right: 0.694vw;
            width: 6.94vw;
            font-size: 0.972vw;
            color: var(--mixtmt_greyColor3);
            text-align: center;
          }
          .el-input {
            color: var(--mixtmt_greyColor2);
            input {
              height: 2.778vw;
              line-height: calc(2.778vw - 2px);
              font-size: 0.972vw;
              background-color: rgba(245, 247, 250, 1);
              padding: 0 4vw 0 1.042vw;
            }
            .el-input__count .el-input__count-inner {
              background-color: rgba(245, 247, 250, 1);
            }
          }
        }
      }
      .el-dialog__footer {
        padding: 2.083vw 2.778vw;
        .dialog-footer {
          display: flex;
          display: -webkit-flex;
          justify-content: center;
          align-items: center;
          span {
            width: 10.416vw;
            height: 2.778vw;
            background-color: var(--mixtmt_whiteColor);
            line-height: calc(2.778vw - 2px);
            color: var(--mixtmt_greyColor2);
            border: 1px solid var(--mixtmt_greyColor6);
            border-radius: 0.347vw;
            &.ok {
              background-color: var(--mixtmt_mainColor3);
              color: var(--mixtmt_whiteColor);
            }
            &:nth-child(2) {
              margin-left: 1.388vw;
            }
          }
        }
      }
    }
  }
}

.mixtmt_pc .baseDialog {
  .el-dialog__wrapper {
    .mixtmt_dialog {
      .el-dialog__headerbtn:focus .el-dialog__close,
      .el-dialog__headerbtn:hover .el-dialog__close {
        color: var(--mixtmt_mainColor);
      }
      .el-dialog__footer {
        .dialog-footer {
          span {
            cursor: pointer;
            &:hover {
              background-color: var(--mixtmt_mainColor6);
              color: var(--mixtmt_whiteColor);
              border-color: var(--mixtmt_mainColor6);
            }
          }
        }
      }
    }
  }
}
</style>
